import React from 'react';

const ConfirmationModal = ({ 
  type, 
  data, 
  onConfirm, 
  onCancel, 
  loading, 
  language, 
  t 
}) => {
  const config = {
    roleChange: { 
      title: t('confirmRoleChange', language), 
      color: 'primary', 
      message: t('changeUserRoleQuestion', language) 
    },
    ban: { 
      title: t('banUser', language), 
      color: 'danger', 
      message: t('banUserQuestion', language) 
    },
    unban: { 
      title: t('unbanUser', language), 
      color: 'primary', 
      message: t('unbanUserQuestion', language) 
    },
    removeApprover: { 
      title: t('removeApprover', language), 
      color: 'primary', 
      message: t('removeApproverQuestion', language) 
    }
  }[type] || {};

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="modal-title">{config.title}</h3>
        <p className="role-management-description">{config.message}</p>
        <div className="modal-actions">
          <button 
            onClick={onConfirm} 
            disabled={loading}
            className={`modal-btn modal-btn-${config.color}`}
          >
            {loading ? t('processing', language) : t('confirm', language)}
          </button>
          <button 
            onClick={onCancel} 
            disabled={loading}
            className="modal-btn modal-btn-secondary"
          >
            {t('cancel', language)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;